<template>
  <div class="giphy giphy__container p-3">
    <div class="d-flex flex-column mt-1 mb-3 justify-content-between">
      <HMSearch
        v-model="searchWord"
        @input="loadGiphies"
        placeholder="COMMUNITY.BUTTON.FIND_GIPHY"
      />
      <div class="d-flex justify-content-end pt-1 giphy__powered-by">
        <img
          :src="require('@/assets/images/community/powered_by_giphy.png')"
          alt="powered by giphy"
        />
      </div>
    </div>
    <div
      class="giphy__images-container d-flex justify-content-start flex-wrap"
      v-infinite-scroll="loadMoreGiphies"
      infinite-scroll-disabled="isLoading"
      infinite-scroll-distance="20"
      infinite-scroll-throttle-delay="500"
    >
      <div
        class="giphy__gif-container mb-2 ml-2"
        v-for="(giphy, i) in giphies"
        :key="i"
      >
        <img :src="giphy" @click="selectGiphy(giphy)" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'GiphyComponent',
  props: {
    searchLimit: {
      type: Number,
      default: 9,
    },
  },
  data() {
    return {
      searchURL: 'https://api.giphy.com/v1/gifs/search?',
      trendingSearchURL: 'https://api.giphy.com/v1/gifs/trending?',
      apiKey: process.env.VUE_APP_GIPHY_KEY,
      giphies: [],
      searchWord: null,
      isLoading: true,
      offset: 0,
    };
  },
  computed: {
    ...mapGetters({
      canLoadMoreGiphies: 'community/canLoadMoreGiphies',
    }),
  },
  methods: {
    async loadGiphies() {
      try {
        if (!this.searchWord) return;
        this.isLoading = true;
        const giphiesArray = await this.$store.dispatch('community/loadGiphy', {
          searchURL: this.searchURL,
          apiKey: this.apiKey,
          searchWord: this.searchWord,
          searchLimit: this.searchLimit,
          offset: this.offset,
        });
        const giphies = giphiesArray.data.map(giphy => {
          return `https://media.giphy.com/media/${giphy.id}/giphy.gif`;
        });
        this.giphies = [...this.giphies, ...giphies];
      } finally {
        this.isLoading = false;
      }
    },
    async loadTrendingGiphies() {
      try {
        this.isLoading = true;
        const giphiesArray = await this.$store.dispatch('community/loadGiphy', {
          searchURL: this.trendingSearchURL,
          apiKey: this.apiKey,
          searchWord: '',
          searchLimit: this.searchLimit,
          offset: this.offset,
        });
        const giphies = giphiesArray.data.map(giphy => {
          return `https://media.giphy.com/media/${giphy.id}/giphy.gif`;
        });
        this.giphies = [...this.giphies, ...giphies];
      } finally {
        this.isLoading = false;
      }
    },
    selectGiphy(giphy) {
      this.$emit('addGiphyToComment', giphy);
    },
    async loadMoreGiphies() {
      if (!this.canLoadMoreGiphies) return;
      this.offset = this.offset + this.searchLimit;
      this.loadGiphies();
    },
  },
  mounted() {
    this.loadTrendingGiphies();
  },
  watch: {
    searchWord: {
      handler: function (value) {
        this.offset = 0;
        this.giphies = [];
      },
      immediate: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';
.giphy {
  &__container {
    background-color: $white;
    max-width: 600px;
    max-height: 520px;
    background-clip: padding-box;
    border-radius: 0.3rem;
    box-shadow: 0 0.25rem 0.5rem rgb(0 0 0 / 20%);
    overflow: hidden;

    @media screen and (max-width: 768px) {
      max-width: 300px;
    }
  }
  &__images-container {
    overflow: hidden;
    min-height: 180px;
    max-height: 350px;

    &:hover {
      overflow: auto;
    }

    &::-webkit-scrollbar {
      width: 6px;
      background-color: $light-gray;
    }

    &::-webkit-scrollbar-track {
      -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
      border-radius: 10px;
      background-color: white;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 10px;
      -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
      background-color: $light-gray;
    }
  }
  &__powered-by {
    margin-right: -2px;
    img {
      max-width: 80px;
      height: auto;
    }
  }
  &__gif-container {
    width: 106px;
    height: 106px;
    border-radius: $border-radius;
    overflow: hidden;

    img {
      width: 100%;
      object-fit: cover;
      cursor: pointer;
      border-radius: $border-radius;
    }
  }
}
</style>
